<template>
  <div class="production">
    <div class="allShrink">
      <div class="header-banner">
        <!-- <div class="login-area" v-if="!showLogin">
          <login-area></login-area>
        </div> -->
        <!-- <div class="swiper">
          <el-carousel class="carousel" :interval="4000" :loop="true" arrow="always" height="500px">
            <el-carousel-item>

              <img src="../../assets/imgs/banner2.png" alt="" />
            </el-carousel-item>
            <el-carousel-item>
              <img src="../../assets/imgs/banner2.png" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div> -->
      </div>
      <!-- 快速入口 -->
      <p-quick-link></p-quick-link>

      <!-- 地图展示 -->
      <MapViewer/>
      <!-- <BaiDuMap></BaiDuMap> -->

      <!-- 供求资讯 -->
      <supply-demand></supply-demand>

      <!-- 成果展示 -->
      <achieve-display></achieve-display>

      <!-- 生产服务动态 -->
      <!-- <production-performance></production-performance> -->

      <!-- 土地托管统计 -->
      <landtrust-statistics></landtrust-statistics>
    </div>
  </div>
</template>

<script>
import { getStore } from "@/js/utils/store";
import LoginArea from "@/components/LoginArea";
import BaiDuMap from "./components/baiduMap.vue";
import MapViewer from "./components/MapViewer.vue";
import PQuickLink from "./components/PQuickLink.vue";
import AchieveDisplay from "./components/AchieveDisplay.vue";
import SupplyDemand from "../homepage/components/SupplyDemand.vue";
import LandtrustStatistics from "./components/LandtrustStatistics.vue";
import ProductionPerformance from "./components/ProductionPerformance.vue";


export default {
  metaInfo: {
    title: window.pageConfiguration.company.title,
    meta: [
      {
        name: "description",
        content: window.pageConfiguration.company.description,
      },
      { name: "keywords", content: window.pageConfiguration.company.keywords1 },
    ],
  },
  components: {
    LoginArea,
    BaiDuMap,
    PQuickLink,
    SupplyDemand,
    AchieveDisplay,
    LandtrustStatistics,
    ProductionPerformance,
    MapViewer,
  },

  data() {
    return {
      showLogin: getStore({ name: "access_token" }),
    };
  },
};
</script>

<style lang="less" scoped>
.production {
  text-align: left;
  background: #fff;
  display: grid;

  .allShrink {
    width: 90%;
    margin: auto;
  }
}
</style>
